import React, { useEffect, useState } from "react";
import styles from "components/dashboard/dashboard.module.scss";
import RefreshButton from "components/shared-ui/button/refresh-button";
import PageTitle from "components/shared-ui/pageTitle";
import PageSubtitle from "components/shared-ui/pageSubTitle";
import Card from "./card/card";
import { useApi } from "utils/hooks/use-api";
import { IBucketListItem } from "api/entities/bucket";
import { getDefaultRequestParams, getEmptyPage } from "redux/reducers/entity";
import { bucketService } from "api/services/bucket-service";
import { Skeleton } from "@mui/material";

const SAMPLE_BUCKETS: IBucketListItem[] = [
  {
    id: "1",
    name: "Sample Bucket 1",
    createdAt: new Date("2024-01-01T00:00:00Z"),
    updatedAt: new Date("2024-01-01T00:00:00Z"),
    ownerId: "owner-1",
    storagePoolId: "pool-1",
    bucketConfig: {
      id: "bucket-config-1",
      bucketId: "1",
      objectLock: false,
      objectVersioning: true,
      createdAt: new Date("2024-01-01T00:00:00Z"),
      updatedAt: new Date("2024-01-01T00:00:00Z"),
    },
    storagePool: {
      id: "pool-1",
      name: "Pool 1",
    },
    applications: [{ id: "app-1", name: "Application 1" }],
    url: "https://sample-bucket-1.example.com",
  },
  {
    id: "2",
    name: "Sample Bucket 2",
    createdAt: new Date("2024-01-02T00:00:00Z"),
    updatedAt: new Date("2024-01-02T00:00:00Z"),
    ownerId: "owner-2",
    storagePoolId: "pool-2",
    bucketConfig: {
      id: "bucket-config-2",
      bucketId: "2",
      objectLock: true,
      objectVersioning: false,
      createdAt: new Date("2024-01-02T00:00:00Z"),
      updatedAt: new Date("2024-01-02T00:00:00Z"),
    },
    storagePool: {
      id: "pool-2",
      name: "Pool 2",
    },
    applications: [{ id: "app-2", name: "Application 2" }],
    url: "https://sample-bucket-2.example.com",
  },
];

function Dashboard() {
  const [bucketApi, isBucketLoading] = useApi();
  const [bucketList, setBucketList] = useState<IBucketListItem[]>(
    getEmptyPage<IBucketListItem>().data,
  );

  function fetchData() {
    bucketApi(
      bucketService.getPage({ ...getDefaultRequestParams(), deleted: false }),
    ).then((p) => {
      setBucketList(p.data);
    });
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={styles.Header}>
        <PageTitle title={"Dashboard"}>
          <RefreshButton onClick={() => fetchData()} />
        </PageTitle>
      </div>
      <div
        style={{
          marginBottom: "16px",
          padding: "12px 16px",
          border: "1px solid #f0b429",
          borderRadius: "6px",
          backgroundColor: "#fff8e1",
          color: "#8a6d3b",
          fontSize: "14px",
        }}
      >
        This preview reflects sample data and is intended for demonstration
        purposes rather than live operational monitoring.
      </div>
      {isBucketLoading ? (
        <Skeleton
          variant="rectangular"
          animation="wave"
          sx={{ height: "100%" }}
        />
      ) : (
        <>
          <PageSubtitle subtitle="Buckets" />
          <div className={styles.bucketSection}>
            {[...SAMPLE_BUCKETS].map((bucket, i) => (
              <Card bucket={bucket} key={bucket.id} />
            ))}
          </div>
        </>
      )}
    </>
  );
}

export default Dashboard;
